import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { jwtDecode, JwtPayload } from 'jwt-decode';

type CustomJwtPayload = JwtPayload & {
  email?: string;
  user_id?: string;
  isStaff?: boolean;
  isGuest?: boolean;
};

type AuthStore = {
  accessToken?: string;
  refreshToken?: string;
  isStaff?: boolean;
  isGuest?: boolean;
  email?: string;
  userId?: string;
  deleteTokens: () => void;
  setTokens: (tokens: { accessToken: string; refreshToken: string }) => void;
  venueSlug: string | undefined;
};

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      accessToken: undefined,
      refreshToken: undefined,
      isStaff: undefined,
      email: undefined,
      userId: undefined,
      setTokens: ({ accessToken, refreshToken }) => {
        const decoded = jwtDecode<CustomJwtPayload>(accessToken);
        console.log('Decoded JWT:', decoded);
        set((state) => ({
          ...state,
          accessToken,
          refreshToken,
          email: decoded?.email,
          userId: decoded?.user_id,
          isStaff: decoded?.isStaff,
          isGuest: decoded?.isGuest,
        }));
      },
      deleteTokens: () =>
        set((state) => ({
          ...state,
          isStaff: undefined,
          isGuest: undefined,
          email: undefined,
          userId: undefined,
          accessToken: undefined,
          refreshToken: undefined,
        })),
      venueSlug: undefined,
    }),
    {
      name: 'auth-store',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
